module.exports = __webpack_public_path__ + "img/new-fleet.0cd223b0.png";